import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var defaultEntityTypePageQueries = {};
export var EntityTypePageQueriesContext = React.createContext(defaultEntityTypePageQueries);
export var EntityTypePageQueriesProvider = createInheritedProvider(EntityTypePageQueriesContext);